var SupportMultipleQtyPopupView, SupportPrintGiftCardVoucherServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportUtilsHelper, SupportViewVoucherServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportViewVoucherServiceActionView = require('./view_voucher_service_action');

SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View');

SupportServiceActionsBaseView = require('./service_action_base');

SupportUtilsHelper = require('../../../helpers/utils');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportPrintGiftCardVoucherServiceActionView = (function(superClass) {
  extend(SupportPrintGiftCardVoucherServiceActionView, superClass);

  function SupportPrintGiftCardVoucherServiceActionView() {
    return SupportPrintGiftCardVoucherServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportPrintGiftCardVoucherServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    if (this.order.groupons.length === 1) {
      return this.addHref(this.getUrlForVoucher(this.order.groupons[0]));
    }
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "print_gift_card_voucher"
    };
    if (this.isSingleGroupon()) {
      hash.service_action = I18n.t("js.modules.support.print_gift_card_voucher");
      this.extendSingleGrouponParams(hash);
    } else {
      hash.service_action = I18n.t("js.modules.support.print_gift_card_vouchers");
    }
    return this.extendHash(hash);
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.actionHandler = function(event) {
    var args, current_order, multipleQtyPopup;
    current_order = Groupon.Support.currentOrder;
    if (this.order.groupons.length > 1) {
      args = {
        orders: this.order,
        serviceActionName: 'print_gift_card_voucher',
        singleActionButtonCallback: this.getUrlForVoucher,
        groupActionButtonCallback: this.getUrlForAllVouchers,
        showgroupActionButton: false,
        title: I18n.t("js.modules.support.print_gift_card_vouchers"),
        singleActionButtonName: I18n.t("js.modules.support.print_gift_card_voucher")
      };
      multipleQtyPopup = new SupportMultipleQtyPopupView(args);
      multipleQtyPopup.render();
    }
    return true;
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.getUrlForAllVouchers = function(order_id) {
    return null;
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.getUrlForVoucher = function(groupon) {
    var order, ref, ref1;
    if (SupportUtilsHelper.isCurrentOrderGoodsDeal()) {
      order = Groupon.Support.currentOrder;
      return "/deals/" + ((ref = order.deal) != null ? ref.id : void 0) + "/gift/" + ((ref1 = order.dealOption) != null ? ref1.id : void 0) + ".pdf";
    } else {
      return "/mygroupons/gifts/envelope/voucher/" + currentUser.id + "/" + groupon.id + ".pdf";
    }
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.addHref = function(url) {
    return this.$el.find('#print_gift_card_voucher').attr('href', url);
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.renderErrorPage = function() {
    return flash('error', "Error when contacting server for Voucher PDF");
  };

  SupportPrintGiftCardVoucherServiceActionView.prototype.events = {
    "click #print_gift_card_voucher": "actionHandler"
  };

  return SupportPrintGiftCardVoucherServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportPrintGiftCardVoucherServiceActionView;

//# sourceMappingURL=data:application/json;base64,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
